import React, { ReactElement } from "react"
import styled, { css } from "styled-components"
import { theme } from "../../../theme"
import { TextBold, TextLink, TextRegular } from "../../atoms/text"
import { formatCommaDate } from "../../formatters"

export type ActivitySource = {
  icon: ReactElement
  color: string
  title: string
}

export type ActivityProps = {
  activitySource?: ActivitySource
  date: string
  description: string
  link?: string
  dataCy?: string
  onClickLink?: () => void
}

export const Activity = (props: ActivityProps) => {
  const { activitySource, date, description, link, dataCy, onClickLink } = props

  const renderActivitySource = (source: ActivitySource) => {
    return (
      <LastActivityItem $color={source.color}>
        {source.icon}
        <TextBold noWrap={true}>{source.title}</TextBold>
      </LastActivityItem>
    )
  }

  return (
    <LastActivityContainer data-cy={dataCy}>
      {activitySource && renderActivitySource(activitySource)}
      <LastActivityItem>
        <ActivityDate noWrap={true}>{formatCommaDate(date)} · </ActivityDate>
        <TextRegular noWrap={true}>{description}</TextRegular>
        <HigherTextLink noWrap={true} onClick={onClickLink}>
          {link}
        </HigherTextLink>
      </LastActivityItem>
    </LastActivityContainer>
  )
}

const LastActivityContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  white-space: pre-line;
`

const ActivityDate = styled(TextRegular)`
  color: ${theme.color.black4};
`

const LastActivityItem = styled.div<{ $color?: string }>`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.s};
  line-height: ${theme.lineHeight.m};
  flex-wrap: wrap;

  ${(p) =>
    css`
      color: ${p.$color};
    `}
  svg {
    width: ${theme.iconSize.xs};
    height: ${theme.iconSize.xs};
    margin-right: ${theme.spacing.s};
  }
`

const HigherTextLink = styled(TextLink)`
  z-index: ${theme.zIndex.medium};
`
